const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8050';

const fetchJson = async (path) => {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${path}`);
  }

  return response.json();
};

export const fetchQuestionData = async () => {
  try {
    const categories = await fetchJson('/api/v1/categories');
    return categories.map(categoryData => ({
      category: categoryData.name,
      subcategories: Array.from(categoryData.subcategories || []),
      path: categoryData.path,
      count: categoryData.question_count,
      description: categoryData.description || `Master ${categoryData.name} through practical examples and step-by-step guidance.`
    }));
  } catch (error) {
    console.error('Error fetching questions:', error);
    return [];
  }
};

export const fetchCategoryQuestions = async (categoryName) => {
  try {
    const payload = await fetchJson(`/api/v1/categories/${categoryName}/questions`);
    return {
      category: {
        name: payload.category.name,
        description: payload.category.description,
        subcategories: payload.category.subcategories,
        questionCount: payload.category.question_count
      },
      questions: payload.questions
    };
  } catch (error) {
    console.error('Error fetching category questions:', error);
    return { category: null, questions: [] };
  }
};

export const fetchFeaturedQuestions = async () => {
  try {
    return fetchJson('/api/v1/questions/featured?limit=6');
  } catch (error) {
    console.error('Error fetching featured questions:', error);
    return [];
  }
};

export const fetchQuestionDetail = async (questionPath) => {
  const encodedPath = questionPath
    .replace(/^\/?questions\//, '')
    .replace(/\.md$/, '')
    .split('/')
    .map(encodeURIComponent)
    .join('/');
  return fetchJson(`/api/v1/questions/detail/${encodedPath}`);
};

export const searchQuestions = async (query, limit = 50) => {
  const params = new URLSearchParams();
  if (query) params.set('q', query);
  params.set('limit', String(limit));
  return fetchJson(`/api/v1/questions?${params.toString()}`);
};

export const getCategoryIcon = (category) => {
  const icons = {
    'Advanced Python Concepts': 'PsychologyIcon',
    'Data Structures': 'StorageIcon',
    'Algorithms': 'TerminalIcon',
    'Design Patterns': 'ArchitectureIcon',
    'Python Core': 'DataObjectIcon',
    'Testing & Debugging': 'BugReportIcon',
    'Web Development': 'WebIcon',
    'Database': 'StorageIcon',
    'Security': 'SecurityIcon',
    'Performance': 'SpeedIcon',
    'Algorithms and Data Structures': 'TerminalIcon'
  };

  return icons[category] || 'CodeIcon';
};
